import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import PropTypes from 'prop-types';
import SearchBar from '../SearchBar/index.jsx';
import SavingsSectionv3 from '../static/SavingsSectionv3.jsx';
import { Helmet } from 'react-helmet';
import TopDrugs from '../TopDrugs/index.jsx';
import TopDrugsNew from '../../components/TopDrugsNew/index.jsx';
import drugs from '../static/TopDrugs';
import {
  HOME_CANONICAL,
  HOME_DESC,
  HOME_OG_DESC,
  HOME_OG_TITLE,
  HOME_TITLE,
  HOME_TITLE_ES,
  HOME_DESC_ES,
  HOMEPAGE_MID_SIGNUP_MODAL,
  INTELLIMIZE_POPULAR_DRUG_CLICK
} from '../../constants/defaults';

import _ from 'lodash';
import BlogPosts from '../NewBlogPosts';
import HomeSignUpv2 from '../HomeSignUp-v2';
import { withTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import FamilywizeFaq from '../common/FamilywizeFaq';
import SkipTo from '../common/Tag/SkipTo';
import loadable from '@loadable/component';
import { modalActions } from '../../reducers/modalSlice';
import PharmaciesBanner from '../PharmaciesBanner';
import { getReferrerDetails } from '../../services/Api/Referral/ReferralService';
import AppsPromoHomeV2 from '../AppsPromoHomeV2';
import { AuthContext } from '../../Contexts';
import TrendingDrugs from '../common/TrendingDrugs/index.js';
import { HOME_PAGE_TEST_SCRIPT } from '../../constants/abTestHomeScript.js';

const AuthenticatedModal = loadable(() =>
  import('../HomeDeliveryNew/AuthenticateModal')
);

if (typeof window !== 'undefined' && !window.__headerScrollInit) {
  window.__headerScrollInit = true;
  window.addEventListener('scroll', () => {
    const header = document.querySelector('.newSearchBar');
    if (!header) return;
    //const isScrolled = window.scrollY > 280;
    const breakpoint = 768;
    const isMobile = window.innerWidth <= breakpoint;
    const scrollThreshold = isMobile ? 180 : 280;
    const isScrolled = window.scrollY > scrollThreshold;
    header.classList.toggle('scrolled', isScrolled);
  });
}

class Home extends Component {
  constructor(props) {
    super(props);
    let repos;
    if (
      typeof window !== 'undefined' &&
      typeof __INITIAL_DATA__ !== 'undefined'
    ) {
      repos = window.__INITIAL_DATA__;
      delete window.__INITIAL_DATA__;
    } else {
      repos = this.props.staticContext.data;
    }

    this.state = {
      repos
    };
  }

  state = {
    rxPageRecentDrug: false,
    isLoading: false,
    openSignupModal: false,
    isRefCode: false,
    referrerUser: {},
    skipEmailScreen: false
  };
  static contextType = AuthContext;

  setSignupModal = value => {
    this.setState({ openSignupModal: value });
  };

  resetReferralState = () => {
    const { location } = this.props;
    if (location && location.state && 'isReferralLoad' in location.state) {
      this.props.history.push({
        state: ''
      });
    }
  };

  handleSignupModalClick = () => {
    this.handleSignupModal();
    this.resetReferralState();
  };

  toggleSearch() {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    const myButton = document.getElementById('mobile-search-icon');
    myButton.dispatchEvent(clickEvent);
  }
  clearDrug() {
    localStorage.removeItem('RecentlyViewedDrugs');
    this.setState({ rxPageRecentDrug: false });
  }

  getReferralUSerDetails = async refCode => {
    try {
      let response = await getReferrerDetails(refCode);
      if (response && response.firstName) {
        this.setState({ referrerUser: response });
        return true;
      }
      return false;
    } catch (err) {
      console.log(err);
    }
  };

  async componentDidMount() {
    if (typeof window !== 'undefined') {
      const recentlyViewedDrugs = JSON.parse(
        localStorage.getItem('RecentlyViewedDrugs')
      );
      !_.isEmpty(recentlyViewedDrugs) &&
        this.setState({ rxPageRecentDrug: true });
    }

    /*
        checking location state (which is set from referral page)
         - if URL have referral code (which is in search param)
         then from api get user details from referral code
         - replace history with
           -- isReferralLoad - to check referral signup modal open one time and when refresh it will not open
           --  prevPath - to redirect after signup
     */
    const { location } = this.props;
    if (location && location.state && !location.state.isReferralLoad) {
      const searchParam = location.state.search;
      if (!_.isNull(searchParam) && !_.isEmpty(searchParam)) {
        if (await this.getReferralUSerDetails(searchParam)) {
          this.setState({ skipEmailScreen: true });
        }
      }
      this.handleSignupModal();
      this.props.history.replace({
        state: {
          isReferralLoad: true,
          prevPath: this.props.location.state.prevPath
        }
      });
    } else {
      this.resetReferralState();
    }

    /*
      this is for /invite/referralCode route
     */
    const code = _.getURLRefCode(this.props);
    if (!_.isEmpty(code)) {
      this.getReferralUSerDetails(code) && this.handleSignupModal();
    }
  }

  /*shouldComponentUpdate(nextProps, nextState) {
    return !(this.state.openSignupModal === nextState.openSignupModal);
  }*/
  componentDidUpdate() {
    document.body.style.overflow = this.state.openSignupModal ? 'hidden' : '';
  }

  topDrugHandler = t => {
    let defaultDrug = {};
    if (!_.isEmpty(this?.state?.repos?.popularDrugs?.drugs)) {
      defaultDrug.title = this?.state?.repos?.popularDrugs?.subhead;
      defaultDrug.drugs = this?.state?.repos?.popularDrugs?.drugs;
    } else {
      defaultDrug.drugs = drugs.newHomeTopDrugs;
      defaultDrug.title = t('Most popular drugs');
    }
    if (typeof window === 'undefined') {
      return defaultDrug;
    }
    const path = window.location.pathname;
    const pathToDrugMap = [
      {
        key: 'blood-pressure',
        drugKey: 'bloodPressureTopDrugs',
        title: 'Top Blood Pressure Drugs'
      },
      {
        key: 'diabetes',
        drugKey: 'diabetesTopDrugs',
        title: 'Top Diabetes Drugs'
      },
      {
        key: 'bloodthinners',
        drugKey: 'bloodThinnersTopDrugs',
        title: 'Top Blood Thinners'
      }
    ];
    for (const { key, drugKey, title } of pathToDrugMap) {
      if (path.includes(key)) {
        let drugsObj = {};
        drugsObj.title = t(title);
        drugsObj.drugs = drugs[drugKey];
        return drugsObj;
      }
    }
    return defaultDrug;
  };

  geLdJson() {
    let LdJson = {
      '@context': 'http://schema.org',
      '@type': 'Organization',
      description:
        'SingleCare is a free prescription discount card. Think of us as your ticket to better savings. SingleCare is free to use, and there are no hidden fees or obligations..',
      url: 'https://www.singlecare.com/',
      logo: 'https://static-singlecare.s3.amazonaws.com/tenant/singlecare/images/main-logo.png',
      name: 'SingleCare',
      contactPoint: [
        {
          '@type': 'ContactPoint',
          telephone: '+1-844-234-3057',
          contactType: 'customer service',
          contactOption: 'TollFree',
          areaServed: ['US', 'CA']
        }
      ],
      sameAs: [
        'https://www.facebook.com/SingleCare/',
        'https://twitter.com/singlecare',
        'https://www.linkedin.com/company/singlecare/',
        'https://www.instagram.com/singlecare/',
        'https://www.youtube.com/channel/UCd9kiPIjCQw95-2BHCYePKA'
      ]
    };
    return JSON.stringify(LdJson);
  }

  setMetaData = () => {
    const { i18n } = this.props;
    let isEs = _.isEqual(i18n.language, 'es');
    return (
      <Helmet>
        <title>{isEs ? HOME_TITLE_ES : HOME_TITLE}</title>
        <meta name="description" content={isEs ? HOME_DESC_ES : HOME_DESC} />
        <meta
          name="google-site-verification"
          content="cwuLTbqDFQXCVR6HYD2QGXryXU9eWcaqNMP6PT9nb48"
        />
        <meta name="msvalidate.01" content="2379A44788D9E36D5937176579661917" />
        <meta name="yandex-verification" content="8a995f8fd1dce3eb" />
        <meta property="og:title" content={HOME_OG_TITLE} />
        <meta property="og:description" content={HOME_OG_DESC} />
        <meta
          property="og:image"
          content={`${HOME_CANONICAL}/content/images/homepage/newSingleCareLogo.jpg`}
        />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${this.props.location.pathname}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
        <link
          rel="canonical"
          href={`https://www.singlecare.com${this.props.location.pathname}`}
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.singlecare.com/es"
          hrefLang="es-us"
        />
        <script type="application/ld+json">{this.geLdJson()}</script>
        {this.props.location.pathname === '/' && (
          <script type="text/javascript">{HOME_PAGE_TEST_SCRIPT}</script>
        )}
      </Helmet>
    );
  };

  handleDrugClick = (e, drugName) => {
    _.sendIntellimizeEvent(INTELLIMIZE_POPULAR_DRUG_CLICK);
    if (!_.isEmpty(drugName)) {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        this.setState({ isLoading: true });
        setTimeout(() => this.setState({ isLoading: false }), 3000);
      } else this.setState({ isLoading: true });
    }
  };

  handleSignupModal = () => {
    this.setSignupModal(true);
    this.props.dispatchHomepageMidSignupModal();
    let { signUpPath, signUpPathWithInvite } = _.getSignUpPath(
      HOMEPAGE_MID_SIGNUP_MODAL
    );
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    let loyaltyPathObj =
      typeof this.props.location.state !== 'undefined' &&
      this.props.location.state.prevPath === '/refer-friends'
        ? {
            loyaltySignupPath: '/refer-friends'
          }
        : signUpPathWithInvite;
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      referralLink: _.getReferralLink(this.context?.userData?.referralCode),
      ...loyaltyPathObj
    });
  };

  hideAuthenticateModal = () => {
    this.setSignupModal(false);
  };

  render() {
    const { t, i18n } = this.props;
    let lang = i18n.language;
    let recentlyViewedDrugs = [];
    if (typeof window !== 'undefined') {
      recentlyViewedDrugs = JSON.parse(
        localStorage.getItem('RecentlyViewedDrugs')
      );
    }
    const isHomepage = this.props.location.pathname === '/';
    const authContext = this.context?.userData;
    // const mProspectId = _.getCookie("mprospect-id");
    return (
      <main>
        {this.state.isLoading ? (
          <div className="loaderCenter mainLoader">
            <img
              src={
                /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
                  ? '/content/images/loader/loader.png'
                  : '/content/images/loader/loading.gif'
              }
              alt="loader"
              className="center"
            />
          </div>
        ) : (
          <div className="homepage homepage-new homepagev2">
            {/* <div className="topShadow"></div> */}
            {this.setMetaData()}
            {!_.isEqual(i18n.language, 'es') && (
              <section id="homeHeroSection">
                <div
                  className={`homeHeroSection-AB ${
                    this.state.rxPageRecentDrug ? 'heroBg minHigh' : 'heroBg'
                  }`}
                >
                  <div className="newHeroSection">
                    <h1 className="mainHeading">
                      <span className="desktop-only">
                        <span className="desktop-show">
                          {t('Real prescription savings')}
                        </span>
                        <span className="desktop-show swoosh">
                          {t('Really')}
                        </span>
                      </span>
                      <span className="mobileHeader mobile-only swoosh">
                        {t('Really')}
                      </span>
                      <span className="mobileHeader mobile-only">
                        {t('Real prescription savings')}
                      </span>
                    </h1>
                  </div>
                  <div
                    className={`newSearchBar ${
                      !authContext?.isLoggedIn ? '' : 'loginNewSearchBar'
                    }`}
                  >
                    <div className="desktop-only">
                      <SearchBar
                        classes="search-container"
                        handleZipCodeChange={() => null}
                        history={this.props.history}
                        showZipCode={false}
                        inputPlaceHolder={`${
                          !this.props.isMobileDevice &&
                          'Search your drug name (ex. Amoxicillin)'
                        }`}
                      />
                    </div>
                    <div
                      className="mobile-only mm"
                      onClick={this.toggleSearch.bind(this)}
                    >
                      <SearchBar
                        classes="search-container"
                        handleZipCodeChange={() => null}
                        history={this.props.history}
                        showZipCode={false}
                        inputPlaceHolder={'Search your drug name'}
                      />
                    </div>
                  </div>

                  {this.state.rxPageRecentDrug && window.innerWidth < 767 && (
                    <div className="newViewedrxSection">
                      <section
                        id="viewed-rx--section"
                        className="viewed-rx less_recently_viewed_items"
                      >
                        <div className="viewed-rx--content">
                          <header className="clear-recently-viewed">
                            <p className="header-text">
                              {t('Recently viewed')}
                            </p>
                            <p className="header-btn">
                              <button
                                type="button"
                                data-mp-text="Clear all recently viewed drug"
                                className="sc-text-btn--white clear-all-btn viewed-rx--clear-all"
                                onClick={this.clearDrug.bind(this)}
                              >
                                Clear
                              </button>
                            </p>
                          </header>

                          <div className="viewed-rx--list">
                            <ul>
                              {recentlyViewedDrugs
                                .slice(0)
                                .reverse()
                                .map((drug, id) => {
                                  return (
                                    <li key={id} className="rx-item">
                                      <a
                                        href={_.withLocale(
                                          lang,
                                          `/prescription/${
                                            drug.SeoName
                                          }?q=${encodeURIComponent(drug.Name)}`
                                        )}
                                        data-mp-text="Recently viewed drug"
                                        className="rx-item--drug-link"
                                      >
                                        <span className="recent-drug--name">
                                          {drug.Name}
                                        </span>
                                      </a>
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                  )}

                  <div
                    className={
                      this.state.rxPageRecentDrug
                        ? 'newTopDrugsSection addBg'
                        : 'newTopDrugsSection'
                    }
                  >
                    <TopDrugsNew handleDrugClick={this.handleDrugClick} />
                  </div>
                </div>
              </section>
            )}
            <section
              id="homepageSearch"
              className={`home-masthead masthead--search show-recent ${
                isHomepage && 'isBTSSHown'
              }`}
            >
              <SkipTo>
                <h1 className="mainHeading">
                  <span className="desktop-only">
                    <span className="desktop-show">
                      {t('Real prescription savings')}
                    </span>
                    <span className="desktop-show swoosh">{t('Really')}</span>
                  </span>
                  <span className="mobileHeader mobile-only swoosh">
                    {t('Really')}
                  </span>
                  <span className="mobileHeader mobile-only">
                    {t('Real prescription savings')}
                  </span>
                </h1>
              </SkipTo>
              {this.state.openSignupModal && (
                <div className="mainModal afterSignupmodal">
                  <div
                    className="transparentBg"
                    onClick={() => this.setSignupModal(false)}
                  ></div>
                  <div className="signUpModal">
                    <AuthenticatedModal
                      referrerUser={this.state.referrerUser}
                      skipEmailScreen={this.state.skipEmailScreen}
                      hideAuthenticateModal={this.hideAuthenticateModal}
                    />
                  </div>
                </div>
              )}
              <div
                id="desktTopSearchbar"
                className="desktop-only homeLandingSearch"
              >
                <SearchBar
                  classes="search-container"
                  handleZipCodeChange={() => null}
                  history={this.props.history}
                  showZipCode={false}
                  inputPlaceHolder={
                    !this.props.isMobileDevice &&
                    t('Enter a drug name (ex. Amoxicillin)')
                  }
                />
              </div>
              {/*<p className="subhead">People used 1634 coupons and saved big today</p>*/}
              <div className="mobile-search">
                <button
                  onClick={this.toggleSearch.bind(this)}
                  className="input-search open-search-mobile mobile-only whiteFocus"
                >
                  {/*<span className="sc-icon sc-icon-search input-search--icon" />*/}
                  <span className="mobile-search-input input-search--placeholder">
                    {t('Search for a drug')}
                  </span>
                </button>
                <div className="site-search-form--query mobile-show">
                  <button
                    type="submit"
                    value="Search"
                    className="search-btn sc-outline-btn--cool-gray homeSearch"
                  >
                    <span className="search-icon">
                      <LazyLoadImage
                        src="/content/images/header/icon-searchNew.svg"
                        alt=""
                        width="24px"
                        height="24px"
                      />
                    </span>
                  </button>
                </div>
              </div>
              {this.state.rxPageRecentDrug && (
                <section
                  id="viewed-rx--section"
                  className="viewed-rx less_recently_viewed_items"
                >
                  <div className="viewed-rx--content">
                    <header className="clear-recently-viewed">
                      <p className="header-text">{t('Recently viewed')}</p>
                    </header>
                    <div className="viewed-rx--list">
                      <ul>
                        {recentlyViewedDrugs
                          .slice(0)
                          .reverse()
                          .map((drug, id) => {
                            return (
                              <li key={id} className="rx-item">
                                <a
                                  href={_.withLocale(
                                    lang,
                                    `/prescription/${
                                      drug.SeoName
                                    }?q=${encodeURIComponent(drug.Name)}`
                                  )}
                                  data-mp-text="Recently viewed drug"
                                  className="rx-item--drug-link"
                                >
                                  <span className="recent-drug--name">
                                    {drug.Name}
                                  </span>
                                </a>
                              </li>
                            );
                          })}
                      </ul>
                      <p className="header-btn">
                        <button
                          type="button"
                          data-mp-text="Clear all recently viewed drug"
                          className="sc-text-btn--white clear-all-btn viewed-rx--clear-all"
                          onClick={this.clearDrug.bind(this)}
                        >
                          {t('Clear all')}
                        </button>
                      </p>
                    </div>
                  </div>
                </section>
              )}
              <TopDrugs
                drugsObj={this.topDrugHandler(t)}
                handleDrugClick={this.handleDrugClick}
              />
            </section>
            <PharmaciesBanner />
            <SavingsSectionv3 />
            {!authContext?.isLoggedIn && (
              <div className="homeSignupSection">
                <HomeSignUpv2 openSignupModal={this.handleSignupModalClick} />
              </div>
            )}

            {/* {API.ALLOW_HOME_DELIVERY && (
              <section className="homeDeliverySection">
                <h2 id="NoteHomeDelivery" className="noteHomeDelivery">
                  <LazyLoadImage
                    className="lazyimage"
                    alt=""
                    src="/content/images/homepage/boxdelivery.png"
                  />
                  <span>{t("New")}</span>&nbsp;
                  {t("Introducing home delivery with GeniusRx")}
                </h2>
                <a
                  id="NoteHomeDeliveryLink"
                  aria-labelledby="NoteHomeDeliveryLink NoteHomeDelivery"
                  href={_.withLocale(lang, "/prescription-delivery")}
                  className="homeDelivery button pink"
                >
                  {t("Learn more")}
                </a>
              </section>
            )} */}
            {this.props.location.pathname.match(
              /familywize|es\/familywize/
            ) && <FamilywizeFaq />}

            <AppsPromoHomeV2
              QRImage={'/content/images/homepagev2/czbygisj_qr_code.svg'}
              appStoreLink={'https://singlecare.onelink.me/OxIQ/5f177f77'}
              playStoreLink={'https://singlecare.onelink.me/OxIQ/6ec13330'}
              altText={t('QR code to download the app')}
            />

            {/*<div className="doctorVisitBanner">
              <div className="title">
                <LazyLoadImage
                  src="/content/images/pharmacy/pill-bottle.svg"
                  alt=""
                  height="48px"
                  width="48px"
                />
                <p>Need a prescription?</p>
              </div>
              <p className="offerTitle">GeniusRx offers online doctors visits.</p>
              <a 
                className="learnButton themeFocus"
                href={_.withLocale(lang, "/prescription-delivery")}
              >
                {t("Learn more")}
              </a>
            </div>*/}
            <TrendingDrugs data={this?.state?.repos?.trendingDrugs} />
            {!_.isEqual(i18n.language, 'es') && (
              <BlogPosts blogWidth={'blogPosts-xl'} />
            )}
          </div>
        )}
      </main>
    );
  }
}

Home.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  history: PropTypes.any
};

const mapDispatchToProps = dispatch => {
  return {
    dispatchHomepageMidSignupModal: () =>
      dispatch(modalActions.homepageMidSignupModal())
  };
};

export default connect(null, mapDispatchToProps)(withTranslation()(Home));
